
import banner_image1 from "../../../assets/images/banner/banner-image1.png"
import banner_image2 from "../../../assets/images/banner/banner-image2.png"
import banner_image3 from "../../../assets/images/banner/banner-image3.png";
import banner_shape from "../../../assets/images/shape/banner-shape.png";
import banner_arry from "../../../assets/images/shape/banner-arry.png";
const Banner =()=>{
    return (
      <>
        {/* Banner area start here */}
        <section className="banner-section">
          <div className="arry">
            <img
              className="animation__arryLeftRight"
              src={banner_arry}
              alt="Image"
            />
          </div>
          <div className="sec-shape">
            <img src={banner_shape} alt="Image" />
          </div>
          <button className="goBottom-btn">
            <svg
              className="animation__arryUpDown"
              width={16}
              height={36}
              viewBox="0 0 16 36"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.8328 6.33334C13.8328 5.17961 13.4907 4.0518 12.8497 3.09251C12.2088 2.13322 11.2977 1.38555 10.2318 0.944039C9.16591 0.502527 7.99302 0.387008 6.86146 0.612088C5.72991 0.837169 4.69051 1.39274 3.8747 2.20855C3.0589 3.02435 2.50332 4.06375 2.27824 5.19531C2.05316 6.32686 2.16868 7.49975 2.61019 8.56566C3.05171 9.63156 3.79938 10.5426 4.75867 11.1836C5.71795 11.8245 6.84577 12.1667 7.99949 12.1667C9.54602 12.1648 11.0287 11.5496 12.1222 10.4561C13.2158 9.3625 13.831 7.87986 13.8328 6.33334ZM3.83283 6.33334C3.83283 5.50925 4.0772 4.70366 4.53504 4.01846C4.99287 3.33325 5.64362 2.7992 6.40498 2.48384C7.16634 2.16847 8.00412 2.08596 8.81237 2.24673C9.62062 2.4075 10.3631 2.80434 10.9458 3.38706C11.5285 3.96978 11.9253 4.71221 12.0861 5.52046C12.2469 6.32871 12.1644 7.16649 11.849 7.92785C11.5336 8.68921 10.9996 9.33995 10.3144 9.79779C9.62916 10.2556 8.82358 10.5 7.99949 10.5C6.89474 10.499 5.83552 10.0597 5.05434 9.27849C4.27316 8.49731 3.83385 7.43809 3.83283 6.33334ZM15.2554 27.4108C15.3327 27.4882 15.3941 27.58 15.436 27.6811C15.4779 27.7822 15.4995 27.8905 15.4995 28C15.4995 28.1094 15.4779 28.2177 15.436 28.3188C15.3941 28.4199 15.3327 28.5118 15.2554 28.5891L8.58869 35.2558C8.51133 35.3332 8.41948 35.3946 8.31839 35.4365C8.2173 35.4783 8.10895 35.4999 7.99953 35.4999C7.8901 35.4999 7.78175 35.4783 7.68066 35.4365C7.57957 35.3946 7.48772 35.3332 7.41036 35.2558L0.743692 28.5891C0.591894 28.432 0.507898 28.2215 0.509797 28.003C0.511696 27.7845 0.599336 27.5755 0.753843 27.421C0.90835 27.2664 1.11736 27.1788 1.33586 27.1769C1.55436 27.175 1.76486 27.259 1.92203 27.4108L7.16616 32.655V18C7.16616 17.779 7.25396 17.567 7.41024 17.4107C7.56652 17.2545 7.77848 17.1667 7.99949 17.1667C8.22051 17.1667 8.43247 17.2545 8.58875 17.4107C8.74503 17.567 8.83283 17.779 8.83283 18V32.655L14.077 27.4109C14.1543 27.3334 14.2462 27.272 14.3473 27.2302C14.4484 27.1883 14.5567 27.1667 14.6661 27.1667C14.7756 27.1667 14.8839 27.1882 14.985 27.2301C15.0861 27.272 15.178 27.3334 15.2554 27.4108Z"
                fill="white"
              />
            </svg>
          </button>
          <div className="swiper banner-slider">
            <div className="swiper-wrapper">
              <div className="swiper-slide">
                <div
                  className="slide-bg"
                  style={{ backgroundImage: `url(${banner_image1})` }}
                />
                <div className="container">
                  <div className="outer-box">
                    <div className="row g-0 align-items-end">
                      <div className="col-lg-8 content-column">
                        <div className="inner-column">
                          <h6
                          style={{lineHeight:'20px', border:'none'}}
                            className="sub-title"
                            data-animation="fadeInUp"
                            data-delay=".3s"
                          >
                            GEO Technical Investigation • Third Party Vendor
                            Inspection • HSEQ Training Consultancy • Calibration
                            Services • Civil Testing
                          </h6>
                          <h1
                            className="title"
                            data-animation="fadeInUp"
                            data-delay=".5s"
                          >
                            Ensuring <span>Quality & Safety</span> Across
                            Industries
                          </h1>
                          <a
                            className="btn-one"
                            data-animation="fadeInUp"
                            data-delay=".8s"
                            href="/contact"
                          >
                            Contact Us
                          </a>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <p
                          className="text"
                          data-animation="fadeInUp"
                          data-delay=".9s"
                        >
                          Pak Arab Inspection Limited Company is an independent
                          inspection and technical services provider delivering
                          reliable assessment, quality assurance, and safety
                          solutions across Saudi Arabia. Our services include
                          GEO Technical Investigation, Third Party Vendor
                          Inspection, HSEQ Training Consultancy, Calibration
                          Services, and Civil Testing.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="swiper-slide">
                <div
                  className="slide-bg"
                  style={{ backgroundImage: `url(${banner_image2})` }}
                />
                <div className="container">
                  <div className="outer-box">
                    <div className="row g-0 align-items-end">
                      <div className="col-lg-8 content-column">
                        <div className="inner-column">
                          <h6
                          style={{lineHeight:'20px', border:'none'}}
                            className="sub-title"
                            data-animation="fadeInUp"
                            data-delay=".3s"
                          >
                            GEO Technical Investigation • Third Party Vendor
                            Inspection • HSEQ Training Consultancy • Calibration
                            Services • Civil Testing
                          </h6>
                          <h1
                            className="title"
                            data-animation="fadeInUp"
                            data-delay=".5s"
                          >
                            Ensuring <span>Quality & Safety</span> Across
                            Industries
                          </h1>
                          <a
                            className="btn-one"
                            data-animation="fadeInUp"
                            data-delay=".8s"
                            href="/contact"
                          >
                            Contact Us
                          </a>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <p
                          className="text"
                          data-animation="fadeInUp"
                          data-delay=".9s"
                        >
                          Pak Arab Inspection Limited Company is an independent
                          inspection and technical services provider delivering
                          reliable assessment, quality assurance, and safety
                          solutions across Saudi Arabia. Our services include
                          GEO Technical Investigation, Third Party Vendor
                          Inspection, HSEQ Training Consultancy, Calibration
                          Services, and Civil Testing.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="swiper-slide">
                <div
                  className="slide-bg"
                  style={{ backgroundImage: `url(${banner_image3})` }}
                />
                <div className="container">
                  <div className="outer-box">
                    <div className="row g-0 align-items-end">
                      <div className="col-lg-8 content-column">
                        <div className="inner-column">
                          <h6
                            className="sub-title"
                            data-animation="fadeInUp"
                            data-delay=".3s"
                            style={{lineHeight:'20px', border:'none'}}
                          >
                            GEO Technical Investigation • Third Party Vendor
                            Inspection • HSEQ Training Consultancy • Calibration
                            Services • Civil Testing
                          </h6>
                          <h1
                            className="title"
                            data-animation="fadeInUp"
                            data-delay=".5s"
                          >
                            Ensuring <span>Quality & Safety</span> Across
                            Industries
                          </h1>
                          <a
                            className="btn-one"
                            data-animation="fadeInUp"
                            data-delay=".8s"
                            href="/contact"
                          >
                            Contact Us
                          </a>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <p
                          className="text"
                          data-animation="fadeInUp"
                          data-delay=".9s"
                        >
                          Pak Arab Inspection Limited Company is an independent
                          inspection and technical services provider delivering
                          reliable assessment, quality assurance, and safety
                          solutions across Saudi Arabia. Our services include
                          GEO Technical Investigation, Third Party Vendor
                          Inspection, HSEQ Training Consultancy, Calibration
                          Services, and Civil Testing.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Banner area end here */}
      </>
    );
}

export default Banner;